<template>
  <form 
    id="cu-form-contact-us" 
    class="cu-form-contact-us"
    @submit.prevent="$emit('submit')"
  >
    <!-- 隐藏字段 -->
    <input name="fid" id="cu-fid" :value="formData.fid" type="hidden">
    <input type="hidden" id="cu-hid-codepage" name="hid_codepage" :value="formData.hidCodepage">
    <input type="hidden" name="showcode" :value="formData.showcode">
    <input type="hidden" name="submitPageURL" :value="formData.submitPageURL">
    <input type="hidden" name="langid" :value="formData.langid">
    <input id="cu-captcha-ticket" name="captcha_ticket" type="text" hidden="">
    <input id="cu-captcha-randstr" name="captcha_randstr" type="text" hidden="">
    <input type="hidden" name="IsNewValidCode" :value="formData.IsNewValidCode">
    <input type="hidden" name="isNotNeedValidate" :value="formData.isNotNeedValidate">
    <input type="hidden" name="email_to" :value="formData.email_to">
    <input type="hidden" name="email_from" :value="formData.email_from">
    <input type="hidden" name="email_subject" :value="formData.email_subject">
    <input type="hidden" name="email_confirm_message" :value="formData.email_confirm_message">
    <input type="hidden" name="hdPrivacy" :value="formData.hdPrivacy ? 'true' : 'false'">
    <input type="hidden" name="hdShare" :value="formData.hdShare ? 'true' : 'false'">
    <input id="cu-captcha-verify-param" name="captchaVerifyParam" value="" type="hidden">
    <input name="showid" id="cu-showid" :value="formData.showid" type="hidden">
    <input name="isCloud" id="cu-is-cloud" value="true" type="hidden">
    <input type="hidden" name="ValType" id="cu-val-type" value="Geetest">
    <input id="cu-lot-number" name="lot_number" value="" type="hidden">
    <input id="cu-captcha-output" name="captcha_output" value="" type="hidden">
    <input id="cu-pass-token" name="pass_token" value="" type="hidden">
    <input id="cu-gen-time" name="gen_time" value="" type="hidden">
    <input id="cu-type-name" name="typename" value="" type="hidden">
    <input id="cu-is-aliyun-valid" name="IsAliyunValid" value="true" type="hidden">
    <input id="cu-referer-link" name="RefererLink" value="https://www.chinaplasonline.com/eMarketplace" type="hidden">

    <!-- 固定标题区域 -->
    <div class="cu-form-header" :class="{ 'cu-form-header--with-close': simple }">
      <div class="cu-font-title cu-font-weight-bold">
        {{ $t('lbl_emp2_ContactUs') }}
      </div>
      <button
        v-if="simple"
        type="button"
        class="cu-form-header-close"
        aria-label="Close"
        @click="$emit('close')"
      >
        <span aria-hidden="true">&times;</span>
      </button>
    </div>

    <!-- 可滚动的表单内容区域 -->
    <div class="cu-form-scrollable-content">
      <div class="cu-cps-form cu-contact-us-form-content">
      <div class="cu-cps-form-group">
        <!-- Reason 下拉 -->
        <div class="cu-contact-us-form-item">
          <div class="cu-form-label-wrapper">
            <label for="cu-contact-us-reason" class="cu-form-label">
              {{ $t('lbl_emp2_ILikeToEnquireAbout') }}
              <span class="cu-required">*</span>
            </label>
          </div>
          <div class="cu-selection-wrapper">
            <selection
              :value="formData.Reason"
              :options="selectionReasonOptions"
              :placeholder="$t('lbl_emp2_PleaseSelect')"
              :mandatory="true"
              :isShowTitle="false"
              :enableValidation="true"
              :allowInput="false"
              @input="handleReasonInput"
              @fromChird_TreeSelected="handleReasonSelected"
              class="cu-contact-us-selection"
            />
          </div>
          <input 
            name="Reason" 
            id="cu-contact-us-reason" 
            :value="formData.Reason" 
            type="hidden" 
            required
          >
          <input 
            name="ReasonText" 
            id="cu-contact-us-reason-text" 
            :value="formData.ReasonText" 
            type="hidden" 
            :required="!simple"
          >
        </div>

        <!-- Message 文本域 -->
        <div class="cu-cps-form-item">
          <label for="cu-message" class="cu-form-label">
            {{ $t('lbl_emp2_Message') }}
            <span class="cu-required">*</span>
          </label>
          <textarea 
            name="message" 
            id="cu-message" 
            :value="formData.message"
            @input="handleInput('message', $event.target.value)"
            class="cu-form-control cu-inputing" 
            maxlength="350" 
            required
          >{{ formData.message }}</textarea>
        </div>

        <template v-if="!simple">
          <!-- Name 输入框 -->
          <div class="cu-cps-form-item">
            <label for="cu-contact-us-name" class="cu-form-label">
              {{ $t('lbl_emp2_Name') }}
              <span class="cu-required">*</span>
            </label>
            <input 
              type="text" 
              id="cu-contact-us-name" 
              name="name" 
              :value="formData.name"
              @input="handleInput('name', $event.target.value)"
              class="cu-form-control" 
              required
            >
          </div>

          <!-- Company 输入框 -->
          <div class="cu-cps-form-item">
            <label for="cu-contact-us-company" class="cu-form-label">
              {{ $t('lbl_emp2_Company') }}
              <span class="cu-required">*</span>
            </label>
            <input 
              type="text" 
              id="cu-contact-us-company" 
              name="Company" 
              :value="formData.Company"
              @input="handleInput('Company', $event.target.value)"
              class="cu-form-control" 
              required
            >
          </div>

          <!-- Country 下拉：统一使用 selection + vue-treeselect，与登录页国家选择风格一致 -->
          <div class="cu-contact-us-form-item">
            <selection
              style="margin-bottom: 0px;"
              :title="$t('lbl_emp2_CountryRegion')"
              label="Name"
              class="mobile-country-select"
            :append-to-body="true"
              :value="formData.Country"
              :options="selectionCountryOptions"
              :ControlId="'cu-contact-us-country'"
              :multiple="false"
              @input="handleCountryCodeInput"
              @fromChird_TreeSelected="handleCountrySelected($event)"
            >
            </selection>
            <!-- 隐藏字段，仍然保留 CountryText 供表单提交使用 -->
            <input 
              name="CountryText" 
              id="cu-contact-us-country-text" 
              :value="formData.CountryText" 
              type="hidden" 
              required
            >
          </div>

          <!-- Mobile 输入框 -->
          <div class="cu-cps-form-item">
            <label for="cu-contact-us-mobile" class="cu-form-label">
              {{ $t('lbl_emp2_MobileNo') }}
              <span class="cu-required">*</span>
            </label>
            <input 
              type="text" 
              id="cu-contact-us-mobile" 
              name="Mobile" 
              :value="formData.Mobile"
              @input="handleMobileInput"
              class="cu-form-control" 
              required
            >
          </div>

          <!-- Email 输入框 -->
          <div class="cu-cps-form-item">
            <label for="cu-contact-us-email" class="cu-form-label">
              {{ $t('lbl_emp2_Email') }}
              <span class="cu-required">*</span>
            </label>
            <input 
              type="email" 
              id="cu-contact-us-email" 
              name="Email" 
              :value="formData.Email"
              @input="handleInput('Email', $event.target.value)"
              class="cu-form-control" 
              required
            >
          </div>
        </template>
      </div>

      <!-- 必填字段提示 -->
      <div class="cu-lineheight cu-form-group cu-mandatory-fields">
        <span class="cu-font-red cu-note">{{ $t('lbl_emp2_MandatoryFields') }}</span>
      </div>

      <!-- 隐私条款复选框 -->
      <div id="cu-pur-item-note" class="cu-pur-item-note">
        <div>
          <div class="cu-form-check">
            <input 
              class="cu-form-check-input" 
              type="checkbox" 
              value="" 
              id="cu-chk-privacy" 
              name="chkPrivacy"
              :checked="formData.hdPrivacy"
              @change="handleInput('hdPrivacy', $event.target.checked)"
              required
            >
            <label class="cu-form-check-label cu-note" for="cu-chk-privacy" v-html="$t('lbl_emp2_PrivacyPolicyAgreement')"></label>
          </div>
        </div>
      </div>
      </div>
    </div>

    <!-- 固定提交按钮区域 -->
    <div class="cu-form-footer">
      <button 
        id="cu-btn-submit-contact-us" 
        type="submit" 
        class="cu-btn cu-btn-red cu-m-auto cu-btn-submit-contact-us"
        :disabled="submitting"
        t_label="btn_emp2_Submit_ContactUs"
      >
        {{ submitting ? $t('lbl_emp2_Submitting') : $t('lbl_emp2_Submit') }}
      </button>
    </div>
  </form>
</template>

<script>
import selection from '../../form/selection.vue';

export default {
  name: 'ContactUsForm',
  components: {
    selection
  },
  props: {
    formData: {
      type: Object,
      required: true
    },
    reasonOptions: {
      type: Array,
      default: () => []
    },
    countryOptions: {
      type: Array,
      default: () => []
    },
    submitting: {
      type: Boolean,
      default: false
    },
    simple: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {};
  },
  computed: {
    selectionCountryOptions() {
      if (this.countryOptions && this.countryOptions.length > 0) {
        return this.countryOptions.map(option => ({
          id: option.value,
          label: option.text
        }));
      }
      return [];
    },
    selectionReasonOptions() {
      if (this.reasonOptions && this.reasonOptions.length > 0) {
        return this.reasonOptions.map(option => ({
          id: option.value,
          label: option.text
        }));
      }
      return [];
    },
    currentReasonLabel() {
      const found = this.reasonOptions.find(r => r.value === this.formData.Reason);
      return found ? found.text : '';
    }
  },
  mounted() {},
  beforeDestroy() {},
  methods: {
    handleInput(field, value) {
      this.$emit('update:formData', { ...this.formData, [field]: value });
    },
    handleMobileInput(event) {
      const value = event.target.value.replace(/[^0-9]/g, '');
      this.handleInput('Mobile', value);
    },
    handleReasonInput(value) {
      // 当 selection 组件值变化时触发
      // value 可能是 id (数字或字符串)，需要确保类型匹配
      const reasonValue = value !== null && value !== undefined ? value : null;
      const selected = this.reasonOptions.find(r => {
        // 确保类型匹配进行比较
        return r.value == reasonValue || String(r.value) === String(reasonValue);
      });
      this.$emit('update:formData', {
        ...this.formData,
        Reason: reasonValue,
        ReasonText: selected ? selected.text : ''
      });
    },
    handleReasonSelected(obj) {
      // 当 selection 组件选择项时触发
      if (obj && obj.id !== null && obj.id !== undefined) {
        const selected = this.reasonOptions.find(r => {
          // 确保类型匹配进行比较
          return r.value == obj.id || String(r.value) === String(obj.id);
        });
        this.$emit('update:formData', {
          ...this.formData,
          Reason: obj.id,
          ReasonText: selected ? selected.text : ''
        });
      }
    },
    handleCountryChange(event) {
      const value = event.target.value;
      const selected = this.countryOptions.find(c => c.value === value);
      this.$emit('update:formData', {
        ...this.formData,
        Country: value,
        CountryText: selected ? selected.text : ''
      });
    },
    handleCountryCodeInput(value) {
      const selected = this.countryOptions.find(c => c.value === value);
      this.$emit('update:formData', {
        ...this.formData,
        Country: value,
        CountryText: selected ? selected.text : ''
      });
    },
    handleCountrySelected(obj) {
      const value = obj && obj.id;
      const selected = this.countryOptions.find(c => c.value === value);
      this.$emit('update:formData', {
        ...this.formData,
        Country: value,
        CountryText: selected ? selected.text : ''
      });
    }
  }
};
</script>

<style scoped>
.cu-form-contact-us {
  display: flex;
  flex-direction: column;
  height: auto;
  overflow: hidden;
  padding: 15px 25px;
  padding-bottom: 15px;
}

.cu-form-header {
  margin-bottom: 8px;
}

.cu-form-header--with-close {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.cu-form-header-close {
  flex-shrink: 0;
  width: 32px;
  height: 32px;
  border: none;
  background: transparent;
  font-size: 24px;
  line-height: 1;
  color: rgba(0, 0, 0, 0.5);
  cursor: pointer;
  padding: 0;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.cu-form-header-close:hover {
  background: rgba(0, 0, 0, 0.06);
  color: rgba(0, 0, 0, 0.8);
}

.cu-form-scrollable-content {
  flex: 0 1 auto;
  overflow-y: auto;
  overflow-x: hidden;
  padding-right: 10px;
  padding-top: 5px;
  padding-bottom: 0;
  margin-right: -10px;
  margin-bottom: 0;
  scrollbar-width: thin;
  scrollbar-color: rgba(0, 0, 0, 0.3) transparent;
  position: relative;
  min-height: 0;
  max-height: 60vh;
}

.cu-form-scrollable-content::-webkit-scrollbar {
  width: 8px;
}

.cu-form-scrollable-content::-webkit-scrollbar-track {
  background: transparent;
}

.cu-form-scrollable-content::-webkit-scrollbar-thumb {
  background-color: rgba(0, 0, 0, 0.3);
  border-radius: 4px;
}

.cu-form-scrollable-content::-webkit-scrollbar-thumb:hover {
  background-color: rgba(0, 0, 0, 0.5);
}

/* 城市/国家选择下拉样式：对齐输入框尺寸与点击区域 */
::v-deep .mobile-country-select .vue-treeselect__control {
  min-height: 40px;
  border: 1px solid rgba(0, 0, 0, 0.23);
  border-radius: 4px;
  padding: 8px 12px;
  background: #fff;
  box-shadow: none;
  width: 100%;
}

/* 文字与占位符样式 */
::v-deep .mobile-country-select .vue-treeselect__single-value {
  color: rgba(0, 0, 0, 0.87);
  font-size: 14px;
  line-height: 20px;
}

::v-deep .mobile-country-select .vue-treeselect__placeholder {
  color: rgba(0, 0, 0, 0.60);
  font-size: 14px;
  line-height: 20px;
}

/* 聚焦时边框高亮，保持与输入框一致 */
::v-deep .mobile-country-select:focus-within .vue-treeselect__control,
::v-deep .mobile-country-select .vue-treeselect--focused .vue-treeselect__control {
  border-color: #7366FF !important;
  box-shadow: 0 0 0 1px rgba(115, 102, 255, 0.15);
}

/* 下拉菜单层级与高度 */
::v-deep .mobile-country-select .vue-treeselect__menu {
  z-index: 2000;
  max-height: min(320px, 50vh);
  min-width: 100%;
  max-width: calc(100vw - 24px);
  overflow-y: auto;
}

.cu-form-footer {
  flex-shrink: 0;
  padding-top: 0;
  margin-top: 8px;
  padding-bottom: 0;
  margin-bottom: 0;
}

.cu-font-title {
  font-size: 1.5rem;
  margin-bottom: 8px;
}

.cu-font-weight-bold {
  font-weight: 700;
}

.cu-form-group {
  margin-bottom: 0.5rem;
}

.cu-form-group.cu-mandatory-fields {
  margin-bottom: 0.15rem;
  margin-top: 0;
}

.cu-cps-form {
  margin-bottom: 0;
}

.cu-cps-form-group {
  margin-bottom: 0;
}

.cu-contact-us-form-item,
.cu-cps-form-item {
  margin-bottom: 0.5rem;
  position: relative;
}

.cu-contact-us-form-item .cu-form-label,
.cu-cps-form-item .cu-form-label {
  z-index: 2;
}

.cu-form-label-wrapper {
  position: relative;
  margin-bottom: 4px;
}

.cu-selection-wrapper {
  position: relative;
  width: 100%;
}

/* selection 组件样式，匹配原有 select 样式 */
.cu-contact-us-selection ::v-deep .vue-treeselect__control {
  min-height: 40px;
  border: 1px solid rgba(0, 0, 0, 0.23);
  border-radius: 4px;
  padding: 8px 12px;
  background: white;
  box-shadow: none;
  width: 100%;
  font-size: 14px;
  font-family: 'Inter', 'Roboto', Arial, sans-serif;
}

.cu-contact-us-selection ::v-deep .vue-treeselect__control:focus-within,
.cu-contact-us-selection ::v-deep .vue-treeselect--focused .vue-treeselect__control {
  border-color: #7366FF;
  outline: none;
}

.cu-contact-us-selection ::v-deep .vue-treeselect__single-value {
  color: rgba(0, 0, 0, 0.87);
  font-size: 14px;
  line-height: 20px;
  margin-top: 0;
}

.cu-contact-us-selection ::v-deep .vue-treeselect__placeholder {
  color: rgba(0, 0, 0, 0.60);
  font-size: 14px;
  line-height: 20px;
  margin-top: 0;
}

.cu-contact-us-selection ::v-deep .vue-treeselect__menu {
  z-index: 2000;
  max-height: 320px;
  overflow-y: auto;
}

.cu-contact-us-selection ::v-deep .vue-treeselect__option {
  white-space: normal;
  word-break: break-word;
  line-height: 1.4;
  font-size: 12px;
  padding: 8px 12px;
}

.cu-form-select,
.cu-form-control {
  width: 100%;
  max-width: 100%;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  padding: 8px 12px;
  padding-top: 18px;
  border: 1px solid rgba(0, 0, 0, 0.23);
  border-radius: 4px;
  font-size: 14px;
  font-family: 'Inter', 'Roboto', Arial, sans-serif;
  background: white;
  box-sizing: border-box;
}

.cu-form-control {
  height: 40px;
}

.cu-form-control.cu-inputing {
  min-height: 80px;
  padding-top: 18px;
  resize: vertical;
}

.cu-form-select:focus,
.cu-form-control:focus {
  outline: none;
  border-color: #7366FF;
}

/* 下拉选项允许换行，避免撑开下拉宽度 */
.cu-form-select option {
  white-space: normal;
  word-break: break-word;
  line-height: 1.4;
  font-size: 12px;
  padding: 8px 12px;
}

.cu-form-label {
  position: absolute;
  left: 15px;
  top: -8px;
  padding: 0 5px;
  background-color: #F8F8F8;
  margin-bottom: 0;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.80);
  font-family: 'Inter', 'Roboto', Arial, sans-serif;
  font-weight: 400;
  line-height: 1.5;
  z-index: 10;
  pointer-events: none;
}

.cu-required {
  color: #CD1515;
  margin-left: 2px;
}

.cu-lineheight {
  line-height: 1.5;
}

.cu-font-red {
  color: #CD1515;
}

.cu-note {
  font-size: 12px;
}

.cu-pur-item-note {
  padding-left: 2px;
  padding-right: 10px;
  padding-top: 0;
  padding-bottom: 0;
  margin-top: 0.25rem;
  margin-bottom: 0;
}

.cu-form-check {
  display: flex;
  align-items: flex-start;
  gap: 8px;
}

.cu-form-check-input {
  margin-top: 2px;
  cursor: pointer;
}

.cu-form-check-label {
  font-size: 12px;
  color: rgba(0, 0, 0, 0.80);
  cursor: pointer;
}

.cu-link-text {
  text-decoration: underline;
  color: #CD1515;
}

.cu-link-text:hover {
  color: #a01010;
}

.cu-mt-3 {
  margin-top: 1rem;
}

.cu-btn {
  padding: 8px 24px;
  height: 35px;
  font-size: 14px;
  display: flex;
  align-items: center;
  border-radius: 5px;
  border: none;
  cursor: pointer;
  transition: background 0.3s;
}

.cu-btn-red {
  background: #dc3545;
  color: white;
}

.cu-btn-red:hover:not(:disabled) {
  background: #c82333;
}

.cu-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.cu-m-auto {
  margin: 0 auto;
}

@media (max-width: 768px) {
  .cu-form-contact-us {
    padding: 16px;
  }

  .cu-form-header {
    margin-bottom: 12px;
  }

  .cu-font-title {
    font-size: 1.25rem;
  }

  .cu-form-label {
    font-size: 13px;
    left: 12px;
  }

  .cu-form-select,
  .cu-form-control {
    padding: 8px 12px;
    padding-top: 18px;
    font-size: 14px;
  }

  .cu-form-control {
    height: 44px;
  }

  /* 移动端 select 折行且不撑破容器 - 仅限Contact Us表单 */
  .cu-form-contact-us .cu-form-select {
    min-width: 0;
    max-width: 100%;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    font-size: 12px;
    /* 控件宽度在小屏上收窄，防止原生下拉溢出屏幕 */
    width: 100%;
    max-width: 92vw;
  }

  .cu-form-select option {
    white-space: normal;
    word-break: break-word;
    font-size: 11px;
    padding: 6px 10px;
  }

  .cu-custom-select {
    padding: 8px 12px;
    padding-top: 16px;
  }

  .cu-custom-select__text,
  .cu-custom-select__option {
    font-size: 12px;
  }

  .cu-form-control.cu-inputing {
    min-height: 100px;
    padding-top: 24px;
  }

  .cu-contact-us-form-item,
  .cu-cps-form-item {
    margin-bottom: 1.25rem;
  }

  .cu-btn {
    height: 44px;
    font-size: 14px;
    width: auto;
    padding-left: 24px;
    padding-right: 24px;
  }

  .cu-form-scrollable-content {
    padding-right: 8px;
    margin-right: -8px;
    max-height: 50vh;
  }

  /* 移动端保持更大点击区域与字号 */
  ::v-deep .mobile-country-select .vue-treeselect__control {
    min-height: 44px;
  }

  ::v-deep .mobile-country-select .vue-treeselect__single-value,
  ::v-deep .mobile-country-select .vue-treeselect__placeholder {
    font-size: 15px;
  }
}
</style>

